import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spin2 } from "components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { savePayments } from "./actions";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { Slider } from "components/fields";
import "./style.scss";

// Cryptomus SVG Icon Component
const CryptomusIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_814_53)">
			<rect width="20" height="20" rx="2.2" fill="black"/>
			<g transform="translate(3.5, 2) scale(0.4)">
				<path d="M30.611 8.507L16.935 0.61C16.654 0.444 16.33 0.357 16 0.357C15.67 0.357 15.346 0.444 15.065 0.61L1.254 8.507C0.635 8.867 0.25 9.532 0.25 10.245V26.036C0.25 26.749 0.634 27.414 1.254 27.774L14.93 35.67C15.211 35.836 15.535 35.923 15.865 35.923C16.195 35.923 16.519 35.836 16.8 35.67L30.477 27.774C31.096 27.414 31.481 26.749 31.481 26.036V10.245C31.481 9.532 31.096 8.867 30.477 8.507H30.611ZM16.242 17.16C16.138 17.221 16.02 17.253 15.899 17.253C15.778 17.253 15.66 17.221 15.556 17.16L2.328 9.487L15.624 1.812C15.728 1.751 15.846 1.719 15.967 1.719C16.088 1.719 16.206 1.751 16.31 1.812L29.605 9.487L16.242 17.16ZM14.93 18.357C15.023 18.441 15.127 18.441 15.242 18.499V34.242L1.946 26.572C1.842 26.511 1.754 26.418 1.693 26.303C1.632 26.188 1.601 26.056 1.601 25.921V10.684L14.93 18.357Z" fill="white"/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_814_53">
				<rect width="20" height="20" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

// NowPayments SVG Icon Component
const NowPaymentsIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_814_53)">
			<rect width="20" height="20" rx="2.2" fill="#68AAFF"/>
			<rect x="5" y="5" width="10" height="10" fill="black"/>
		</g>
		<defs>
			<clipPath id="clip0_814_53">
				<rect width="20" height="20" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

// OxaPay SVG Icon Component
const OxaPayIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_826_222)">
			<path d="M16 0H4C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0Z" fill="#1C39BB"/>
			<path d="M12.6071 7H15.4123C15.8864 7.00009 16.341 7.17789 16.6763 7.49431C17.0115 7.81073 17.1999 8.23986 17.2 8.68734V11.9724C17.2 12.2449 17.0853 12.5063 16.8811 12.699C16.6769 12.8917 16.4 13 16.1112 13V8.6724C16.1112 8.49734 16.0376 8.32945 15.9064 8.20566C15.7752 8.08187 15.5974 8.01233 15.4119 8.01233H12.6362C12.5326 8.01249 12.4303 8.03439 12.3367 8.07645C12.2431 8.11851 12.1606 8.17967 12.0951 8.25551L11.303 9.17891L10.6 8.36668L11.2544 7.60657C11.418 7.41699 11.6243 7.26418 11.8583 7.15926C12.0923 7.05434 12.3481 6.99994 12.6071 7Z" fill="white"/>
			<path d="M8.51476 12.3928C8.35645 12.5823 8.15687 12.7351 7.93051 12.84C7.70415 12.9449 7.45669 12.9993 7.20608 12.9993H4.52996C4.07121 12.9993 3.63124 12.8216 3.30682 12.5052C2.9824 12.1888 2.8001 11.7597 2.8 11.3122V8.68714C2.8001 8.23965 2.9824 7.81052 3.30682 7.49413C3.63124 7.17774 4.07121 7 4.52996 7H7.21569C7.46631 6.99999 7.71378 7.05441 7.94014 7.15931C8.1665 7.26422 8.36608 7.41698 8.52438 7.6065L11.9786 11.7439C12.0419 11.8198 12.1217 11.8809 12.2123 11.923C12.3028 11.965 12.4018 11.9869 12.5021 11.9871H14.8V13H12.475C12.2244 13 11.9769 12.9456 11.7506 12.8407C11.5242 12.7358 11.3246 12.583 11.1663 12.3935L7.7121 8.25676C7.64877 8.18092 7.56895 8.11977 7.47842 8.07771C7.38789 8.03566 7.28891 8.01376 7.18863 8.0136H4.52889C4.34944 8.0136 4.17735 8.08314 4.05046 8.20691C3.92357 8.33068 3.85229 8.49855 3.85229 8.67359V11.3292C3.85229 11.5042 3.92357 11.6721 4.05046 11.7959C4.17735 11.9196 4.34944 11.9892 4.52889 11.9892H7.17724C7.27748 11.9891 7.37644 11.9673 7.46693 11.9252C7.55742 11.8831 7.63716 11.8219 7.70035 11.746L8.47915 10.8137L9.15575 11.6255L8.51476 12.3928Z" fill="white"/>
		</g>
		<defs>
			<clipPath id="clip0_826_222">
				<rect width="20" height="20" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

// Eye Icon for Show/Hide Password
const EyeIcon = ({ show }) => (
	<svg 
		width="20" 
		height="20" 
		viewBox="0 0 24 24" 
		fill="none" 
		stroke="currentColor" 
		strokeWidth="2" 
		strokeLinecap="round" 
		strokeLinejoin="round"
		style={{ cursor: 'pointer' }}
	>
		{show ? (
			<>
				<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
				<circle cx="12" cy="12" r="3" />
			</>
		) : (
			<>
				<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
				<line x1="1" y1="1" x2="23" y2="23" />
			</>
		)}
	</svg>
);

const LoadingPlaceholder = () => (
	<div className="settings-content p-4">
		<div className="d-flex align-items-center justify-content-center">
			<Spin2 />
		</div>
	</div>
);

const Step3 = ({settings, setStep, skipStep}) => {
	const [loading, setLoading] = useState(false);
	const [showCryptomusApiKey, setShowCryptomusApiKey] = useState(false);
	const [showCryptomusMerchantId, setShowCryptomusMerchantId] = useState(false);
	const [showNowpaymentsApiKey, setShowNowpaymentsApiKey] = useState(false);
	const [showNowpaymentsIpnSecret, setShowNowpaymentsIpnSecret] = useState(false);
	const [showOxapayApiKey, setShowOxapayApiKey] = useState(false);
	const [initialValues, setInitialValue] = useState({
		cryptomus_api_key: '',
		cryptomus_merchant_id: '',
		nowpayments_api_key: '',
		nowpayments_ipn_secret: '',
		oxapay_api_key: ''
	});
	let dispatch = useDispatch();

	useEffect(() => {
		if (Object.keys(settings.shop).length) {
			const { cryptomus_api_key, cryptomus_merchant_id, nowpayments_api_key, nowpayments_ipn_secret, oxapay_api_key } = settings.shop;
			setInitialValue({
				cryptomus_api_key: cryptomus_api_key || '',
				cryptomus_merchant_id: cryptomus_merchant_id || '',
				nowpayments_api_key: nowpayments_api_key || '',
				nowpayments_ipn_secret: nowpayments_ipn_secret || '',
				oxapay_api_key: oxapay_api_key || ''
			});
		}
	}, [Object.keys(settings.shop).length]);

	const validationSchema = Yup.object().shape({
		cryptomus_api_key: Yup.string(),
		cryptomus_merchant_id: Yup.string(),
		nowpayments_api_key: Yup.string(),
		nowpayments_ipn_secret: Yup.string(),
		oxapay_api_key: Yup.string()
	}).test('cryptomus-fields', 'Both Cryptomus fields are required when one is provided', function(values) {
		const { cryptomus_api_key, cryptomus_merchant_id } = values;
		if (cryptomus_api_key || cryptomus_merchant_id) {
			if (!cryptomus_api_key) {
				return this.createError({
					path: 'cryptomus_api_key',
					message: 'API Key is required when Merchant ID is provided'
				});
			}
			if (!cryptomus_merchant_id) {
				return this.createError({
					path: 'cryptomus_merchant_id',
					message: 'Merchant ID is required when API Key is provided'
				});
			}
		}
		return true;
	}).test('nowpayments-fields', 'Both NOWPayments fields are required when one is provided', function(values) {
		const { nowpayments_api_key, nowpayments_ipn_secret } = values;
		if (nowpayments_api_key || nowpayments_ipn_secret) {
			if (!nowpayments_api_key) {
				return this.createError({
					path: 'nowpayments_api_key',
					message: 'API Key is required when IPN Secret is provided'
				});
			}
			if (!nowpayments_ipn_secret) {
				return this.createError({
					path: 'nowpayments_ipn_secret',
					message: 'IPN Secret is required when API Key is provided'
				});
			}
		}
		return true;
	});

	const handleDeauthorizeCryptomus = () => {
		form.setValues({
			...form.values,
			cryptomus_api_key: '',
			cryptomus_merchant_id: ''
		});
		form.setTouched({
			...form.touched,
			cryptomus_api_key: false,
			cryptomus_merchant_id: false
		});
		if (typeof window !== 'undefined') {
			localStorage.setItem('cryptomus_manually_cleared', 'true');
		}
	};

	const handleDeauthorizeNowPayments = () => {
		form.setValues({
			...form.values,
			nowpayments_api_key: '',
			nowpayments_ipn_secret: ''
		});
		form.setTouched({
			...form.touched,
			nowpayments_api_key: false,
			nowpayments_ipn_secret: false
		});
		if (typeof window !== 'undefined') {
			localStorage.setItem('nowpayments_manually_cleared', 'true');
		}
	};

	const handleDeauthorizeOxaPay = () => {
		form.setValues({
			...form.values,
			oxapay_api_key: ''
		});
		form.setTouched({
			...form.touched,
			oxapay_api_key: false
		});
		if (typeof window !== 'undefined') {
			localStorage.setItem('oxapay_manually_cleared', 'true');
		}
	};

	const handleNextStep = async (values) => {
		setLoading(true);
		try {
			// Track if providers were explicitly cleared
			const wasCryptomusCleared = !values.cryptomus_api_key && !values.cryptomus_merchant_id;
			const wasNowPaymentsCleared = !values.nowpayments_api_key && !values.nowpayments_ipn_secret;
			const wasOxaPayCleared = !values.oxapay_api_key;

			// Remember cleared state in localStorage
			if (typeof window !== 'undefined') {
				if (wasCryptomusCleared) {
					localStorage.setItem('cryptomus_manually_cleared', 'true');
				} else if (values.cryptomus_api_key && values.cryptomus_merchant_id) {
					localStorage.removeItem('cryptomus_manually_cleared');
				}

				if (wasNowPaymentsCleared) {
					localStorage.setItem('nowpayments_manually_cleared', 'true');
				} else if (values.nowpayments_api_key && values.nowpayments_ipn_secret) {
					localStorage.removeItem('nowpayments_manually_cleared');
				}

				if (wasOxaPayCleared) {
					localStorage.setItem('oxapay_manually_cleared', 'true');
				} else if (values.oxapay_api_key) {
					localStorage.removeItem('oxapay_manually_cleared');
				}
			}

			await dispatch(savePayments(values));
			setStep();
		} catch (err) {
			console.error('Error saving payment settings:', err);
			toastAlert('error', err.error || 'Failed to save settings');
		} finally {
			setLoading(false);
		}
	};

	let form = useFormik({
		initialValues,
		enableReinitialize: true,
		onSubmit: handleNextStep,
		validationSchema
	});

	// Check if any field has been partially filled
	const hasPartialCryptomus = Boolean(form.values.cryptomus_api_key) !== Boolean(form.values.cryptomus_merchant_id);
	const hasPartialNowPayments = Boolean(form.values.nowpayments_api_key) !== Boolean(form.values.nowpayments_ipn_secret);
	const hasPartialCredentials = hasPartialCryptomus || hasPartialNowPayments;

	if (loading && !form.dirty) {
		return <LoadingPlaceholder />;
	}

	return (
		<form onSubmit={form.handleSubmit}>
			<h4 className="settings-content-title">Crypto</h4>
			<p className="settings-content-subtitle">Accept cryptocurrency payments through secure and reliable crypto payment processors.</p>

			<div className="crypto-provider-wrapper">
				<div className="payment-container-header">
					<div className="d-flex">
						<OxaPayIcon />
						<div>
							<span>OxaPay</span>
							<span className={form.values.oxapay_api_key ? "connected-status" : ""}>
								{form.values.oxapay_api_key ? "Connected" : "Connect your OxaPay account"}
							</span>
						</div>
					</div>
					{form.values.oxapay_api_key && (
						<Button 
							size="small" 
							type="button" 
							onClick={handleDeauthorizeOxaPay}
						>
							Deauthorize
						</Button>
					)}
				</div>

				<div className="p-3">
					<div className="alert purple show mb-3" style={{ borderColor: 'var(--purple1)', padding: '8px 16px', backgroundColor: 'var(--purple0)', minHeight: '36px' }}>
						<div className="alert-content d-flex justify-content-between align-items-center" style={{ margin: 0 }}>
							<div style={{ 
								display: 'flex', 
								alignItems: 'center',
								gap: '8px',
								margin: 0
							}}>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<circle cx="10" cy="10" r="7.5" stroke="#6A3CE2" strokeWidth="1.5"/>
									<path d="M7.5 7.5C7.5 6.11929 8.61929 5 10 5C11.3807 5 12.5 6.11929 12.5 7.5C12.5 8.5 11.5 9 10 9.5V11" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<circle cx="10" cy="14" r="0.5" fill="#6A3CE2"/>
								</svg>
								<span style={{ 
									color: 'var(--black9)', 
									fontSize: '14px', 
									fontWeight: '600', 
									fontFamily: 'Inter',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>How to Get an API Key?</span>
							</div>
							<div 
								style={{ 
									display: 'flex', 
									alignItems: 'center', 
									gap: '4px', 
									cursor: 'pointer',
									margin: 0
								}}
								onClick={() => window.open('https://app.oxapay.com/merchant-service', '_blank')}
							>
								<span style={{ 
									color: 'var(--purple6)', 
									fontSize: '13px', 
									fontFamily: 'Inter', 
									fontWeight: '600',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>Help Article</span>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<path d="M4.16675 10H15.8334" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 15L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 5L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</div>
						</div>
					</div>

					<div>
						<div className="mb-4">
							<div className="paylixecommerce-label">API Key</div>
							<div className="position-relative">
								<input
									type={showOxapayApiKey ? "text" : "password"}
									className={`paylixecommerce-input ${form.touched.oxapay_api_key && form.errors.oxapay_api_key ? 'is-invalid' : ''}`}
									placeholder="API Key"
									name="oxapay_api_key"
									value={form.values.oxapay_api_key}
									onChange={form.handleChange}
									onBlur={form.handleBlur}
								/>
								{form.values.oxapay_api_key && (
									<div 
										onClick={() => setShowOxapayApiKey(!showOxapayApiKey)}
										style={{
											position: 'absolute',
											right: '10px',
											top: '50%',
											transform: 'translateY(-50%)',
											cursor: 'pointer',
											color: '#6B7280'
										}}
									>
										<EyeIcon show={showOxapayApiKey} />
									</div>
								)}
								{form.touched.oxapay_api_key && form.errors.oxapay_api_key && (
									<div className="invalid-feedback">{form.errors.oxapay_api_key}</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="crypto-provider-wrapper mt-4">
				<div className="payment-container-header">
					<div className="d-flex">
						<NowPaymentsIcon />
						<div>
							<span>NOWPayments</span>
							<span className={form.values.nowpayments_api_key && form.values.nowpayments_ipn_secret ? "connected-status" : ""}>
								{form.values.nowpayments_api_key && form.values.nowpayments_ipn_secret ? "Connected" : "Connect your NOWPayments account"}
							</span>
						</div>
					</div>
					{form.values.nowpayments_api_key && form.values.nowpayments_ipn_secret && (
						<Button 
							size="small" 
							type="button" 
							onClick={handleDeauthorizeNowPayments}
						>
							Deauthorize
						</Button>
					)}
				</div>

				<div className="p-3">
					<div className="alert purple show mb-3" style={{ borderColor: 'var(--purple1)', padding: '8px 16px', backgroundColor: 'var(--purple0)', minHeight: '36px' }}>
						<div className="alert-content d-flex justify-content-between align-items-center" style={{ margin: 0 }}>
							<div style={{ 
								display: 'flex', 
								alignItems: 'center',
								gap: '8px',
								margin: 0
							}}>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<circle cx="10" cy="10" r="7.5" stroke="#6A3CE2" strokeWidth="1.5"/>
									<path d="M7.5 7.5C7.5 6.11929 8.61929 5 10 5C11.3807 5 12.5 6.11929 12.5 7.5C12.5 8.5 11.5 9 10 9.5V11" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<circle cx="10" cy="14" r="0.5" fill="#6A3CE2"/>
								</svg>
								<span style={{ 
									color: 'var(--black9)', 
									fontSize: '14px', 
									fontWeight: '600', 
									fontFamily: 'Inter',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>How to Get a Payment API Key?</span>
							</div>
							<div 
								style={{ 
									display: 'flex', 
									alignItems: 'center', 
									gap: '4px', 
									cursor: 'pointer',
									margin: 0
								}}
								onClick={() => window.open('https://account.nowpayments.io/store-settings#notifications', '_blank')}
							>
								<span style={{ 
									color: 'var(--purple6)', 
									fontSize: '13px', 
									fontFamily: 'Inter', 
									fontWeight: '600',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>Help Article</span>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<path d="M4.16675 10H15.8334" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 15L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 5L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</div>
						</div>
					</div>

					<div>
						<div className="mb-4">
							<div className="paylixecommerce-label">API Key</div>
							<div className="position-relative">
								<input
									type={showNowpaymentsApiKey ? "text" : "password"}
									className={`paylixecommerce-input ${form.touched.nowpayments_api_key && form.errors.nowpayments_api_key ? 'is-invalid' : ''}`}
									placeholder="API Key"
									name="nowpayments_api_key"
									value={form.values.nowpayments_api_key}
									onChange={form.handleChange}
									onBlur={form.handleBlur}
								/>
								{form.values.nowpayments_api_key && (
									<div 
										onClick={() => setShowNowpaymentsApiKey(!showNowpaymentsApiKey)}
										style={{
											position: 'absolute',
											right: '10px',
											top: '50%',
											transform: 'translateY(-50%)',
											cursor: 'pointer',
											color: '#6B7280'
										}}
									>
										<EyeIcon show={showNowpaymentsApiKey} />
									</div>
								)}
								{form.touched.nowpayments_api_key && form.errors.nowpayments_api_key && (
									<div className="invalid-feedback">{form.errors.nowpayments_api_key}</div>
								)}
							</div>
						</div>
						<div>
							<div className="paylixecommerce-label">IPN Secret</div>
							<div className="position-relative">
								<input
									type={showNowpaymentsIpnSecret ? "text" : "password"}
									className={`paylixecommerce-input ${form.touched.nowpayments_ipn_secret && form.errors.nowpayments_ipn_secret ? 'is-invalid' : ''}`}
									placeholder="IPN Secret"
									name="nowpayments_ipn_secret"
									value={form.values.nowpayments_ipn_secret}
									onChange={form.handleChange}
									onBlur={form.handleBlur}
								/>
								{form.values.nowpayments_ipn_secret && (
									<div 
										onClick={() => setShowNowpaymentsIpnSecret(!showNowpaymentsIpnSecret)}
										style={{
											position: 'absolute',
											right: '10px',
											top: '50%',
											transform: 'translateY(-50%)',
											cursor: 'pointer',
											color: '#6B7280'
										}}
									>
										<EyeIcon show={showNowpaymentsIpnSecret} />
									</div>
								)}
								{form.touched.nowpayments_ipn_secret && form.errors.nowpayments_ipn_secret && (
									<div className="invalid-feedback">{form.errors.nowpayments_ipn_secret}</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="crypto-provider-wrapper mt-4">
				<div className="payment-container-header">
					<div className="d-flex">
						<CryptomusIcon />
						<div>
							<span>Cryptomus</span>
							<span className={form.values.cryptomus_api_key && form.values.cryptomus_merchant_id ? "connected-status" : ""}>
								{form.values.cryptomus_api_key && form.values.cryptomus_merchant_id ? "Connected" : "Connect your Cryptomus account"}
							</span>
						</div>
					</div>
					{form.values.cryptomus_api_key && form.values.cryptomus_merchant_id && (
						<Button 
							size="small" 
							type="button" 
							onClick={handleDeauthorizeCryptomus}
						>
							Deauthorize
						</Button>
					)}
				</div>

				<div className="p-3">
					<div className="alert purple show mb-3" style={{ borderColor: 'var(--purple1)', padding: '8px 16px', backgroundColor: 'var(--purple0)', minHeight: '36px' }}>
						<div className="alert-content d-flex justify-content-between align-items-center" style={{ margin: 0 }}>
							<div style={{ 
								display: 'flex', 
								alignItems: 'center',
								gap: '8px',
								margin: 0
							}}>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<circle cx="10" cy="10" r="7.5" stroke="#6A3CE2" strokeWidth="1.5"/>
									<path d="M7.5 7.5C7.5 6.11929 8.61929 5 10 5C11.3807 5 12.5 6.11929 12.5 7.5C12.5 8.5 11.5 9 10 9.5V11" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<circle cx="10" cy="14" r="0.5" fill="#6A3CE2"/>
								</svg>
								<span style={{ 
									color: 'var(--black9)', 
									fontSize: '14px', 
									fontWeight: '600', 
									fontFamily: 'Inter',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>How to Get a Payment API Key?</span>
							</div>
							<div 
								style={{ 
									display: 'flex', 
									alignItems: 'center', 
									gap: '4px', 
									cursor: 'pointer',
									margin: 0
								}}
								onClick={() => window.open('https://doc.cryptomus.com/personal/general/getting-api-keys', '_blank')}
							>
								<span style={{ 
									color: 'var(--purple6)', 
									fontSize: '13px', 
									fontFamily: 'Inter', 
									fontWeight: '600',
									lineHeight: '20px',
									margin: 0,
									padding: 0
								}}>Help Article</span>
								<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
									<path d="M4.16675 10H15.8334" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 15L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									<path d="M10.8333 5L15.8333 10" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</div>
						</div>
					</div>

					<div>
						<div className="mb-4">
							<div className="paylixecommerce-label">Payment API Key</div>
							<div className="position-relative">
								<input
									type={showCryptomusApiKey ? "text" : "password"}
									className={`paylixecommerce-input ${form.touched.cryptomus_api_key && form.errors.cryptomus_api_key ? 'is-invalid' : ''}`}
									placeholder="Payment API Key"
									name="cryptomus_api_key"
									value={form.values.cryptomus_api_key}
									onChange={form.handleChange}
									onBlur={form.handleBlur}
								/>
								{form.values.cryptomus_api_key && (
									<div 
										onClick={() => setShowCryptomusApiKey(!showCryptomusApiKey)}
										style={{
											position: 'absolute',
											right: '10px',
											top: '50%',
											transform: 'translateY(-50%)',
											cursor: 'pointer',
											color: '#6B7280'
										}}
									>
										<EyeIcon show={showCryptomusApiKey} />
									</div>
								)}
								{form.touched.cryptomus_api_key && form.errors.cryptomus_api_key && (
									<div className="invalid-feedback">{form.errors.cryptomus_api_key}</div>
								)}
							</div>
						</div>
						<div>
							<div className="paylixecommerce-label">Merchant ID</div>
							<div className="position-relative">
								<input
									type={showCryptomusMerchantId ? "text" : "password"}
									className={`paylixecommerce-input ${form.touched.cryptomus_merchant_id && form.errors.cryptomus_merchant_id ? 'is-invalid' : ''}`}
									placeholder="Merchant ID"
									name="cryptomus_merchant_id"
									value={form.values.cryptomus_merchant_id}
									onChange={form.handleChange}
									onBlur={form.handleBlur}
								/>
								{form.values.cryptomus_merchant_id && (
									<div 
										onClick={() => setShowCryptomusMerchantId(!showCryptomusMerchantId)}
										style={{
											position: 'absolute',
											right: '10px',
											top: '50%',
											transform: 'translateY(-50%)',
											cursor: 'pointer',
											color: '#6B7280'
										}}
									>
										<EyeIcon show={showCryptomusMerchantId} />
									</div>
								)}
								{form.touched.cryptomus_merchant_id && form.errors.cryptomus_merchant_id && (
									<div className="invalid-feedback">{form.errors.cryptomus_merchant_id}</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="setup-screen-step-buttons">
				<Button variant="secondary" size="large" type="button" onClick={skipStep}>
					Skip Step
				</Button>
				<Button 
					id="next-step-button"
					variant="primary" 
					size="large" 
					type="submit"
					disabled={hasPartialCredentials}
				>
					{loading ? <Spin2 /> : 'Next Step'}
				</Button>
			</div>
		</form>
	);
};

export default Step3;
